<template>
  <div :class="{ 'has-error': !!errorMessage, success: meta.valid }" class="flex flex-col gap-1">
    <label class="font-semibold" :for="name"
      >{{ label }}<span v-if="required" class="text-red-600">*</span></label
    >
    <select
      :id="name"
      :name="name"
      :placeholder="placeholder"
      :required="required"
      v-model="inputValue"
      @blur="handleBlur"
      @change="emitValue"
      class="rounded border px-5 py-3"
    >
      <option disabled value="">-</option>
      <option v-for="(el, idx) in options" :key="idx" :value="el.id">{{ el.name }}</option>
    </select>

    <p v-show="errorMessage || meta.valid" class="help-message text-red-500">
      {{ errorMessage }}
    </p>
  </div>
</template>

<script>
import { toRef, ref } from 'vue';
import { useField } from 'vee-validate';
import { useI18n } from 'vue-i18n';
import * as yup from 'yup';

export default {
  props: {
    type: {
      type: String,
      default: 'text',
    },
    value: {
      type: [String, Number],
      default: undefined,
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    successMessage: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    required: {
      type: Boolean,
      default: true,
    },
    property: {
      type: Number,
      default: undefined,
    },
    defaultSelectValue: {
      type: Object,
      default: undefined,
    },
  },
  setup(props) {
    const { t } = useI18n();
    const name = toRef(props, 'name');
    let rules = yup.number();
    if (props.required) {
      rules = rules.required(t('warning.REQUIRED_MESSAGE'));
    }

    const defaultValue = props?.defaultSelectValue?.id;

    const { meta, value, errorMessage, validate, handleBlur, handleChange } = useField(
      name,
      rules,
      {
        initialValue: defaultValue,
      },
    );

    // Ensure the value is set correctly when defaultValues are provided
    const inputValue = value;

    return {
      inputValue,
      errorMessage,
      validate,
      meta,
      handleBlur,
      handleChange,
    };
  },
  methods: {
    emitValue() {
      this.$emit('valueChanged', {
        value: this.inputValue,
        property: this.property,
        level: 1,
        data_type: this.dataType,
      });
    },
    async validateField() {
      const validatedData = await this.validate();

      const v = this.inputValue;
      const normalized =
        v === null || v === undefined || v === '' || v === 'None' || v === 'null'
          ? []
          : [Number(v)];

      return {
        value: normalized.filter(x => Number.isInteger(x) && x > 0),
        valid: validatedData.valid,
        mode: 'multi',
        property: this.property,
      };
    },
  },

  watch: {
    inputValue(newVal) {
      this.emitValue();
    },
  },
};
</script>

<style scoped>
/* Your styles here */
</style>
